export default "__VITE_ASSET__Bv78n57I__"